<template>
  <div class="calculator-container">
    <div class="background-overlay">
      <h1 class="title">КАЛЬКУЛЯТОР</h1>
      <div class="tab-container desktop-tabs" v-if="!isMobile">
        <div v-for="tab in tabs" :key="tab.label" class="tab-with-cost">
          <button
              :class="['tab', { active: selectedTab === tab.label }]"
              @click="selectTab(tab.label)">
            {{ tab.label }}
          </button>

          <!-- Блок стоимости -->
          <div  class="tab-cost">
            <p class="tab-cost-text-title"> {{ tabCosts[tab.label] }} руб. </p>
            <p class="tab-cost-text"> за {{squareMeters}} кв.м</p>
          </div>
        </div>
      </div>
      <!-- Мобильный свайпер -->
      <div class="mobile-swiper" v-else>
        <div class="swipe-tabs">
          <div class="" v-for="(tab) in tabs"
               :key="tab.label">
          <div
              class="swipe-tab"
              :class="[ { active: selectedTab === tab.label }]"
              @click="selectTab(tab.label)">
            {{ tab.label }}
          </div>
          <div  class="tab-cost">
            <p class="tab-cost-text-title"> {{ tabCosts[tab.label] }} руб. </p>
            <p class="tab-cost-text"> за {{squareMeters}} кв.м</p>
          </div>
          </div>
        </div>
      </div>

      <!-- Контент табов -->
      <div class="content-container">

        <AppComplexCleaning
            v-if="selectedTab !== 'Мытье окон'"
            :square-meters="squareMeters"
            @update-square-meters="squareMeters = $event"
            :baseRate="getCurrentRate(currentTabData)"
            :isMobile = "isMobile"
            :tasks="currentTabData.tasks"
            :services="currentTabData.services"
            :selectedTab = "selectedTab"
        />
          <AppWindowCleaning
              v-if="selectedTab === 'Мытье окон'"
              :isAfter="isAfter"
              :isStandard="isStandard"
              @update:isAfter="val => isAfter = val"
              @update:isStandard="val => isStandard = val"
              :square-meters="squareMeters"
              @update-square-meters="squareMeters = $event"
              ref="windowCleaning"
          />
        </div>
    </div>
  </div>
</template>


<script>
  import AppComplexCleaning from '@/components/ComplexCleaning.vue'
  import AppWindowCleaning from '@/components/WindowCleaning.vue'


  export default {
    name: "CleaningCostCalculator",
    components: { AppWindowCleaning, AppComplexCleaning, },
    data() {
      return {
        selectedTab: "Комплексная уборка",
        squareMeters: 100,
        selectedTabIndex: 0,
        isMobile: false,
        isAfter: false,
        isStandard: true,
        tabs: [
          {
            label: "Комплексная уборка",
            rate: 65,
            tasks: [ "Комнаты/прихожая:",
              "Влажная уборка на высоту 1,8 метров (радиаторы, розетки, выключатели и т.д.)",
              "Уборка пыли на горизонтальных поверхностях на высоту 1,8 метра",
              "Уборка пыли с декора, рамок, часов светильников и т.д. на высоту 1,8 метров",
              "Мытье пола и плинтусов",
              "Пылесосим мебель* при наличии пылесоса",
              "Мытье дверных блоков и ручек",
              "Мытье зеркал и стеклянных поверхностей",
              "Замена постельного белья* если предоставлено",
              "Заправляем кровать/кровати",
              "Раскладываем вещи",
              "Кухня:",
              "Влажная уборка на высоту 1,8 метров",
              "Уборка пыли на горизонтальных поверхностях на высоту 1,8 метра",
              "Мытье фасадов мебели и фурнитуры от нестойких загрязнений",
              "Уборка пыли с декора на высоту 1,8 метров",
              "Мытье рабочего фартука и столешниц (легкие жировые загрязнения)",
              "Мытье варочной поверхности",
              "Мытье раковины, смесителя",
              "Мытье кухонной техники снаружи",
              "Мытье посуды (1 раковина)",
              "Мытье пола и плинтусов",
              "Мытье дверных блоков и фурнитуры",
              "Мытье зеркал и стеклянных поверхностей",
              "Мытье и дезинфекция мусорной корзины, вынос мусора",
              "Ванная комната:",
              "Мытье и дезинфекция сантехники",
              "Мытье ванной/душевой кабины, биде",
              "Удаление локальных загрязнений на стенах на высоту 1.8 метров",
              "Мытье дверных блоков и ручек",
              "Мытье зеркал",
              "Мытье фасадов мебели на высоту 1,8 метров",
              "Мытье и дезинфекция мусорной корзины, вынос мусора"], // массив задач
            services: [
              { name: "Мытье холодильника внутри", price: 500 },
              { name: "Мытье духового шкафа внутри", price: 600 },
              { name: "Мытье микроволновой печи внутри", price: 350 },
              { name: "Мытье люстры простой конструкции", price: 300 },
              { name: "Мытье люстры сложной конструкции", price: 900 },
              { name: "Мытье лотка питомца, замена наполнителя", price: 300 },
              { name: "Обработка плесени и грибка в ванной комнате", price: 350 },
              { name: "Удаление ржавчины", price: 350 },
              { name: "Удаление граффити", price: 500 },
              { name: "Уборка стандартного балкона", price: 750 },
              { name: "Уборка нестандартного балкона", price: 1000 },
              { name: "Глажение белья (1 час работы)", price: 600 },
              { name: "Парогенератор", price: 600 },
              { name: "Мой первый заказ, скидка 10%", price: 0, isDiscount: true }
            ], // массив доп. услуг
          },
          {
            label: "Генеральная уборка",
            rate: 150,
            tasks: [
              "Комнаты/прихожая:",
              "Влажная уборка на полную высоту помещения",
              "Уборка пыли на горизонтальных поверхностях на всю высоту",
              "Уборка пыли с декора, рамок, часов, светильников и т.д. на всю высоту помещения",
              "Обеспыливание/мытье стен на всю высоту помещения",
              "Удаление стойких локальных загрязнений",
              "Обеспыливание потолка",
              "Мытье люстр и торшеров",
              "Мытье радиаторов, розеток, выключателей, труб",
              "Уборка пыли с карнизов и кондиционеров",
              "Мытье пола и плинтусов",
              "Пылесосим мебель, ковры, напольные покрытия",
              "Мытье мебели внутри, где убраны личные вещи",
              "Обработка кожаной мебели специальными средствами",
              "Мытье дверных блоков и фурнитуры",
              "Мытье зеркал и стеклянных поверхностей",
              "Замена постельного белья* если предоставлено",
              "Заправляем кровать/кровати",
              "Раскладываем вещи",
              "Кухня:",
              "Влажная уборка на полную высоту помещения",
              "Уборка пыли на горизонтальных поверхностях на полную высоту",
              "Мытье фасадов мебели и фурнитуры от стойких загрязнений",
              "Обеспыливание/мытье стен на всю высоту помещения",
              "Удаление стойких локальных загрязнений",
              "Обеспыливание потолка",
              "Мытье люстр и торшеров",
              "Мытье радиаторов, розеток, выключателей, труб",
              "Уборка пыли с карнизов и кондиционеров",
              "Мытье пола и плинтусов",
              "Удаление стойких жировых загрязнений с рабочего фартука и столешниц",
              "Мытье варочной поверхности от жировых загрязнений",
              "Мытье кухонной техники снаружи и внутри",
              "Мытье кухонных шкафов внутри",
              "Мытье и дезинфекция раковины и смесителя",
              "Мытье вытяжки и фильтров* если фильтры предварительно сняты",
              "Мытье посуды (1 раковина)",
              "Мытье дверных блоков и фурнитуры",
              "Мытье зеркал и стеклянных поверхностей",
              "Мытье и дезинфекция мусорной корзины, вынос мусора",
              "Ванная комната:",
              "Мытье и дезинфекция сантехники, удаление водного и мыльного налета",
              "Мытье ванной/душевой кабины, биде",
              "Удаление загрязнений с плитки и меж плит на всю высоту помещения",
              "Мытье дверных блоков и дверных ручек",
              "Мытье зеркал",
              "Мытье фасадов мебели и фурнитуры",
              "Мытье и дезинфекция мусорной корзины, вынос мусора",
              "Мытье пола и плинтусов"
            ],
            services: [
              { name: "Мытье люстры сложной конструкции", price: 900 },
              { name: "Мытье лотка питомца, замена наполнителя", price: 300 },
              { name: "Глажение белья (1 час работы)", price: 600 },
              { name: "Обработка плесени и грибка в ванной комнате", price: 350 },
              { name: "Удаление ржавчины", price: 350 },
              { name: "Удаление граффити", price: 500 },
              { name: "Уборка стандартного балкона, без остекления", price: 750 },
              { name: "Уборка нестандартного балкона, без остекления", price: 1000 },
              { name: "Мой первый заказ, скидка 10%", price: 0, isDiscount: true }
              // { name: "Повышенное загрязнение", price: 0 }, // отображай как "+50%" к стоимости — логика отдельно
            ]
          },
          {
            label: "Уборка после ремонта",
            rate: 180,
            tasks: [
              "На всей площади:",
              "Уборка послестроительной пыли на всех поверхностях (горизонтальные и вертикальные)",
              "Удаление следов скотча, краски, строительной смеси, граффити",
              "Тщательное мытье пола и плинтусов",
              "Обеспыливание потолка",
              "Мытье осветительных приборов",
              "Удаление пыли с кондиционеров и карнизов",
              "Двери, дверные блоки, фурнитура",
              "Уборка пыли со всей новой мебели (снаружи и внутри)",
              "Удаление стрейч-пленки с новой мебели, бытовой техники",
              "Мытье отопительной системы",
              "Мытье плитки, меж плит",
              "Мытье сантехники, раковины, ванны и/или душевой кабины, биде",
              "Особенности уборки стен и потолков:",
              "Обеспыливание и/или мытье стен и потолков",
              "Удаление следов строительных материалов, краски, скотча",
              "Использование профессиональных инструментов: пылесос, мопы, пароочиститель",
              "Для деликатных покрытий — сухая уборка мягким мопом",
              "Для плитки и камня — специализированные моющие средства и пароочиститель"
            ],
            services: [
              { name: "Мытье люстры сложной конструкции", price: 900 },
              { name: "Глажение белья (1 час работы)", price: 600 },
              { name: "Уборка стандартного балкона", price: 750 },
              { name: "Уборка нестандартного балкона", price: 1000 },
              { name: "Мой первый заказ, скидка 10%", price: 0, isDiscount: true }
            ]
          },
          {
            label: "Мытье окон",
            rate: 60,
            tasks: [],
            services: [],
          }
        ]

      };
    },
    computed: {
      currentTabData() {
        return this.tabs.find(tab => tab.label === this.selectedTab);
      },
      calculatedCosts() {
        return this.tabs.reduce((acc, tab) => {
          acc[tab.label] = this.squareMeters * tab.rate;
          return acc;
        }, {});
      },
      // tabCosts() {
      //   const result = {};
      //   this.tabs.forEach(tab => {
      //     // if (tab.label === 'Мытье окон') {
      //     //   result[tab.label] = this.$refs.windowCleaning?.calculateTotalCost?.() ?? 0;
      //     // }
      //     // else {
      //     result[tab.label] = this.squareMeters * tab.rate;
      //     // }
      //   });
      //   return result;
      // },
      tabCosts() {
        const result = {};
        this.tabs.forEach(tab => {
          result[tab.label] = this.squareMeters * this.getCurrentRate(tab);
        });
        return result;
      }
    },
    methods: {
      selectTab(tab) {
        this.selectedTab = tab;
      },
      getCurrentRate(tab) {
        const s = this.squareMeters;

        // ----- КОМПЛЕКСНАЯ УБОРКА -----
        if (tab.label === 'Комплексная уборка') {

          // 1) 40–100 м²
          if (s <= 100) return 75;

          // 2) 100–200 м² — плавное снижение 75 → 53
          const maxRate = 75;
          const minRate = 53;
          const sMin = 100;
          const sMax = 200;

          let rate = maxRate - (maxRate - minRate) * ((s - sMin) / (sMax - sMin));
          return Math.round(rate);
        }

        // ----- ГЕНЕРАЛЬНАЯ УБОРКА -----
        if (tab.label === 'Генеральная уборка') {

          // 40–80 м²
          if (s <= 80) return 225;

          // Плавное снижение 225 → 150 (на 200 м²)
          const maxRate = 225;
          const minRate = 150;
          const sMin = 80;
          const sMax = 200;

          let rate = maxRate - (maxRate - minRate) * ((s - sMin) / (sMax - sMin));
          return Math.round(rate);
        }

        // ----- УБОРКА ПОСЛЕ РЕМОНТА -----
        if (tab.label === 'Уборка после ремонта') {
          return s <= 150 ? 180 : 168;
        }

        // ----- МЫТЬЁ ОКОН -----
        if (tab.label === 'Мытье окон') {
          const sqm = this.squareMeters;
          if (this.isAfter) {
            return this.isStandard ? (sqm >= 100 ? 50 : 80) : 90;
          } else {
            return this.isStandard ? (sqm >= 100 ? 50 : 60) : 80;
          }
        }

        return tab.rate;
      },

      selectTabByIndex(index) {
        this.selectedTabIndex = index;
      },
      handleResize() {
        this.isMobile = window.innerWidth <= 768;
      },
      getTabProps(tab) {
        if (tab.label === 'Мытье окон') {
          return {};
        }
        return {
          baseRate: tab.rate,
          tasks: tab.tasks,
          services: tab.services
        };
      },

    },
    mounted() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    }

  };
</script>

<style scoped>
/* Скрываем свайпер на desktop */
.desktop-tabs {
  display: flex;
  gap: 20px;
}

.mobile-swiper {
  display: none;
}

@media (max-width: 768px) {
  .desktop-tabs {
    display: none;
  }

  .mobile-swiper {
    display: block;
    margin-bottom: 10px;

  }
  .swipe-tabs {
    display: flex;
    overflow-x: auto;
    gap: 12px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 10px 0;
    width: calc(100vw - 40px);

    scrollbar-width: none;         /* Firefox */
    -ms-overflow-style: none;      /* IE/Edge */
  }
  .swipe-tabs::-webkit-scrollbar {
    display: none;                 /* Chrome/Safari */
  }


  .tab-with-cost {
    flex: 0 0 auto;
    scroll-snap-align: start;
    width: calc(100vw - 40px); /* чуть меньше вьюпорта */
  }

  .swipe-tab {
    white-space: nowrap;
    width: auto; /* <<< вместо 55% */
    min-width: 197px;
    text-align: center;
    padding: 10px 16px;
    font-size: 12px;
    font-family: Arial, sans-serif;
    letter-spacing: 0.08rem;
    font-weight: 500;
    border: 2px solid white;
    border-radius: 30px;
    background-color: transparent;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    flex-shrink: 0;
    transition: all 0.3s ease;
  }


  .swipe-tab.active {
    background-color: white;
    color: black;
  }
}


</style>

